export const SET_MFA_LIST = 'SET_MFA_LIST'
export const RESET_MFA_LIST = 'RESET_MFA_LIST'
